import TorizonUpdateStatus from '../enums/torizon-update-status';

interface TorizonUpdateState {
  robotId: string;
  torizonUpdateStatus: TorizonUpdateStatus;
}

export const isTorizonUpdateState = (input: any): input is TorizonUpdateState => {
  return (
    input != null &&
    typeof input.robotId === 'string' &&
    Object.values(TorizonUpdateStatus).includes(input.torizonUpdateStatus)
  );
};

export default TorizonUpdateState;

export const mockTorizonUpdateState = {
  robotId: 'robot-1',
  torizonUpdateStatus: TorizonUpdateStatus.IN_PROGRESS,
} as TorizonUpdateState;
